import script from "./ImageGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageGallery.vue?vue&type=script&setup=true&lang=ts"

import "./ImageGallery.vue?vue&type=style&index=0&id=882cf068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-882cf068"]])

export default __exports__